import React from "react";
import { Phone, MessageCircle } from "lucide-react";

export default function StickyMobileCall() {
  return (
    <div data-testid="sticky-mobile-call" className="sticky-call">
      <a
        href="tel:0746329111"
        data-testid="sticky-call-btn"
        className="flex-1 btn-gold justify-center py-3 text-[15px] shadow-xl"
      >
        <Phone className="h-4 w-4" strokeWidth={2.6} />
        Sună acum
      </a>
      <a
        href="https://wa.me/40746329111"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp-btn"
        className="h-12 w-12 rounded-full bg-[#25D366] hover:bg-[#1EBE5D] flex items-center justify-center text-white flex-shrink-0 shadow-lg transition-colors"
        aria-label="WhatsApp"
      >
        <MessageCircle className="h-5 w-5" strokeWidth={2.2} />
      </a>
    </div>
  );
}
